import { Document, Page, Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer'
import Logo from '../../../../assets/images/brand/IBSC.png';
import Stamp from '../../../../assets/images/brand/star-stamp.png';
import Border from '../../../../assets/images/certificates/IBSC.png';

const formatDateWithSuperscript = (dateString) => {
    if (!dateString) return '';

    const parts = dateString.split(' ');

    if (parts.length < 3) return dateString;

    let day = parts[0].match(/\d+/)[0];
    const suffix = parts[0].replace(/\d+/, '');
    const month = parts[1];
    const year = parts[2];

    day = day.padStart(2, '0');

    return { day, suffix, month, year };
};

const IBSCOfficialCertificatePreview = ({ data }) => {
    // const formattedDate = formatDateWithSuperscript(data[0]?.completion_date);
    // const formattedCertificateDate = formatDateWithSuperscript(data[0]?.certificate_date);
    Font.register({
        family: 'Open Sans',
        src: require('../../../../assets/fonts/OpenSans-Regular.ttf')
    });
    Font.register({
        family: 'Open Sans Bold',
        src: require('../../../../assets/fonts/OpenSans-SemiBold.ttf')
    });
    Font.register({
        family: 'Open Sans Extra Bold',
        src: require('../../../../assets/fonts/OpenSans-Bold.ttf')
    });

    // Styles
    const styles = StyleSheet.create({
        page: {
            fontFamily: 'Open Sans',
            position: 'relative',
            padding: 0,
        },
        borderImage: {
            position: 'absolute',
            top: -4.5,
            left: -3,
            width: '101%',
            height: '101%',
            objectFit: 'cover',
        },
        contentWrapper: {
            paddingTop: 55,
            paddingBottom: 25,
            paddingHorizontal: 20,
            height: '100%',
        },
        text: {
            fontFamily: 'Open Sans',
            fontSize: 16,
            textAlign: 'justify',
            fontWeight: 100,
            marginBottom: 20,
        },
        stuName: {
            fontFamily: 'Open Sans Bold',
            fontSize: 20,
            textAlign: 'justify',
            marginBottom: 20,
        },
        degreeText: {
            fontFamily: 'Open Sans Bold',
            fontSize: 20,
            textAlign: 'justify',
            marginTop: 20,
            marginBottom: 20,
        },
        textSentence: {
            fontFamily: 'Open Sans',
            fontSize: 16,
            textAlign: 'justify',
            fontWeight: 100,
            marginBottom: 5,
        },
        detailsText: {
            fontFamily: 'Open Sans',
            fontSize: 8,
            textAlign: 'justify',
            fontWeight: 600,
            marginBottom: 2,
        },
        regText: {
            fontFamily: 'Open Sans Extra Bold',
            fontSize: 9,
            textAlign: 'justify',
            marginTop: 8,
        },
        signatureText: {
            fontFamily: 'Open Sans',
            fontSize: 12,
            textAlign: 'justify',
            fontWeight: 200,
            marginTop: 30,
            marginBottom: 20,
        },
        signatureTextBottom: {
            fontFamily: 'Open Sans',
            fontSize: 12,
            textAlign: 'justify',
            fontWeight: 200,
            marginTop: 50,
        },
        scanText: {
            fontSize: 5,
            textAlign: 'justify',
            fontWeight: 100,
            marginBottom: 20,
        },
        superscript: {
            fontSize: 10,
            verticalAlign: 'super',
        },
        image: {
            width: 125
        },
        logoSec: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 25,
        },
        approveSec: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 20
        },
        leftSec: {
            flex: 1,
            alignItems: "center",
        },
        stampSec: {
            flex: 1,
            alignItems: "center",
        },
        stampImage: {
            width: 195,
        },
        rightSec: {
            flex: 1,
            alignItems: "center",
        },
        qrImage: {
            marginTop: 15,
            width: 70,
            height: 70,
        },
        bodySec: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            marginVertical: 10,
        },
    });

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.contentWrapper}>
                    <View style={styles.logoSec}>
                        <Image style={styles.image} src={data[0]?.certificate_template?.header_logo} />
                    </View>
                    <View style={styles.bodySec}>
                        <Text style={styles.text}>{data[0]?.certificate_phrase_1}</Text>
                        <Text style={styles.stuName}>xxxx xxxxxx xxxx</Text>
                        <Text style={styles.textSentence}>
                            {data[0]?.certificate_phrase_2}
                        </Text>
                        <Text style={styles.textSentence}>
                            {data[0]?.certificate_phrase_3}
                        </Text>
                        <Text style={styles.degreeText}>xxxx xxxx xxxx xxxxxx</Text>
                        <Text style={styles.textSentence}>{data[0]?.conducted_by_phrase}</Text>
                        <Text style={styles.textSentence}>IBS College of TVET</Text>
                        <Text style={styles.textSentence}> {data[0]?.completion_phrase} xxxx xxxx</Text>
                    </View>
                    <View style={styles.approveSec}>
                        <View style={styles.leftSec}>
                            <Text style={styles.signatureText}>{data[0]?.signature_designation_1}</Text>
                            <Text style={styles.signatureTextBottom}>{data[0]?.signature_designation_2}</Text>
                        </View>
                        <View style={styles.stampSec}>
                            <Image style={styles.stampImage} src={data[0]?.certificate_template?.footor_logo} />
                        </View>
                        <View style={styles.rightSec}>
                            <Image style={styles.qrImage} src={data[1]} />
                            <Text style={styles.scanText}>Scan to verify certificate.</Text>
                            <Text style={styles.detailsText}>Document Ref: xxxxxxxxx</Text>
                            <Text style={styles.detailsText}>Completion Date: xx xxxxxx xxxx</Text>
                            <Text style={styles.regText}>NTC REG#: 010</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    );
}

export default IBSCOfficialCertificatePreview;